import React, { useState } from "react";

interface Props {
  edgeOfInterest: any;
  setEdgeOfInterest: any;
  graphData: any;
  setGraphData: any;
  setModalOption: any;
}

export const EdgeModule: React.FC<Props> = ({
  edgeOfInterest,
  setEdgeOfInterest,
  graphData,
  setGraphData,
  setModalOption,
}) => {
  const [isEditing, setEditing] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const deleteSpecificEdge = (edge: any) => {
    let remainingEdges = graphData["links"].filter(
      (obj: any) => obj.index !== edge.index
    );
    setGraphData({ ...graphData, links: remainingEdges });
    setModalOption("General Information");
  };

  const saveEdgeInfo = async (edgeToChange: any) => {
    let edgeArray: any = graphData["links"];
    edgeArray[edgeToChange.index] == edgeToChange;

    setGraphData({ ...graphData, link: edgeArray });
  };

  return (
    <div className="p-4">
      <div className="">
        <div className="grid grid-cols-6 my-2">
          <button
            onClick={() => setModalOption("General Information")}
            className="col-span-1 w-1/3 hover:cursor-pointer  hover:bg-blue-600 bg-blue-500 rounded-lg  text-white shadow-md py-1 px-3 flex flex-row font-semibold text-center  justify-center items-center space-x-1 "
          >
            {" "}
            X
          </button>

          <div className="font-bold text-lg col-span-4 text-center text-ellipsis overflow-hidden  ">
            Link Information
          </div>
          <button
            onClick={() => setEditing(!isEditing)}
            className="col-span-1   hover:cursor-pointer  hover:bg-blue-600 bg-blue-500 rounded-lg  text-white shadow-md py-1 px-3 flex flex-row font-semibold text-center  justify-center items-center space-x-1 "
          >
            {" "}
            {!isEditing ? "Edit" : "Back"}
          </button>
        </div>
        {!isEditing ? (
          <div className="items-center place-content-center text-center ">
            <div className="flex flex-row justify-between">
              <label className="block text-sm font-bold ">Source:</label>
              <p className="text-gray-700 text-sm">
                {edgeOfInterest.source?.name
                  ? edgeOfInterest.source.name
                  : "No Name"}{" "}
                - ({edgeOfInterest.source.id})
              </p>
            </div>
            <div className="flex flex-row justify-between">
              <label className="block text-sm font-bold ">Target:</label>
              <p className="text-gray-700 text-sm">
                {edgeOfInterest.target?.name
                  ? edgeOfInterest.target.name
                  : "No Name"}{" "}
                - ({edgeOfInterest.target.id})
              </p>
            </div>

            <div className="flex flex-row justify-between">
              <label className="block text-sm font-bold ">Edge Name:</label>
              <p className="text-gray-700 text-sm">
                {edgeOfInterest.name || "Unnamed Connection"}
              </p>
            </div>

            <br />

            <div className="flex flex-row justify-between">
              <label className="block text-sm font-bold ">Connection Id:</label>
              <p className="text-gray-700 text-sm">{edgeOfInterest.id}</p>
            </div>
            <div className="w-full">
              <div className="w-full">
                <label className=" text-sm font-bold text-left w-full float-left">
                  Desciption:
                </label>
              </div>
              <div className="rows-span-1 max-h-30 ">
                <p className="text-gray-700 text-sm text-left">
                  {edgeOfInterest.description || "No Description"}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="flex flex-col">
              <label className="text-sm font-medium ml-2  float-left">
                {" "}
                Name
              </label>
              <input
                value={edgeOfInterest.name}
                className="border-0 px-3 py-3 m-1 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder={"Add/Change Node Name"}
                onChange={(e) =>
                  setEdgeOfInterest({
                    ...edgeOfInterest,
                    name: e.target.value,
                  })
                }
              ></input>
              <label className="text-sm font-medium ml-2 my-2">
                {" "}
                Description
              </label>
              <form>
                <textarea
                  id="editor"
                  rows={15}
                  onChange={(e) =>
                    setEdgeOfInterest({
                      ...edgeOfInterest,
                      description: e.target.value,
                    })
                  }
                  maxLength={2000}
                  value={
                    edgeOfInterest.description !== "" ||
                    edgeOfInterest.desciption !== undefined
                      ? edgeOfInterest.description
                      : ""
                  }
                  placeholder={"Node Information goes here"}
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                ></textarea>
              </form>
            </div>

            <button
              onClick={() => saveEdgeInfo(edgeOfInterest)}
              className="my-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
            >
              Save Edits
            </button>
            <div className="flex flew-row justify-between ">
              <button
                onClick={() => setIsDeleting(!isDeleting)}
                className="my-2 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
              >
                {" "}
                Delete Edge
              </button>
            </div>
            {isDeleting && (
              <div>
                {" "}
                <p className="text-sm font-semibold text-center">
                  Are you sure? Once you delete you can&apos;t get your edge
                  back.
                </p>
                <div className="flex flew-row justify-between m-2">
                  <button
                    onClick={() => setIsDeleting(!isDeleting)}
                    className="m-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
                  >
                    {" "}
                    No
                  </button>
                  <button
                    onClick={() => deleteSpecificEdge(edgeOfInterest.id)}
                    className="m-2 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
                  >
                    {" "}
                    Yes
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
